import styled, {keyframes} from "styled-components/macro";
import {fadeIn} from 'react-animations';

const bounceAnimation = keyframes`${fadeIn}`;
const AnimatedDiv = styled.div`
  animation: 0.5s ${bounceAnimation};
`;

export default AnimatedDiv;
